import React from 'react'

export const ArrowRightSvg: React.FC = () => {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="2.05692"
        y1="1.06575"
        x2="7.06568"
        y2="6.63104"
        stroke="black"
        strokeWidth="1.76923"
        strokeLinecap="round"
      />
      <line
        x1="0.884615"
        y1="-0.884615"
        x2="8.37194"
        y2="-0.884615"
        transform="matrix(0.668965 -0.743294 -0.743294 -0.668965 0.807617 12.5)"
        stroke="black"
        strokeWidth="1.76923"
        strokeLinecap="round"
      />
    </svg>
  )
}
